/**
 * Upload files for contractor progress attachments.
 * Backend requires Sha256 (or Content) alongside FilePath from FileUploader.
 */
import DefaultApiService from "../../../../../infrastructure/api/default";

const bufferToHex = (buffer) =>
  Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

export const computeSha256Hex = async (file) => {
  const buffer = await file.arrayBuffer();
  if (window.crypto?.subtle) {
    const digest = await window.crypto.subtle.digest("SHA-256", buffer);
    return bufferToHex(digest);
  }
  // Fallback: send raw content later if hash unavailable
  return null;
};

export const uploadProgressAttachments = async (fileList, moduleName = "SLN") => {
  const files = Array.from(fileList || []);
  if (!files.length) return [];

  const prepared = await Promise.all(
    files.map(async (file) => {
      const sha256 = await computeSha256Hex(file);
      return { file, sha256 };
    })
  );

  const uploadPayload = prepared.map(({ file }, index) => ({
    file,
    name: file.name || `attachment-${index + 1}`,
  }));

  const result = await DefaultApiService.uploadFile(uploadPayload, moduleName);
  if (result?.isSuccess === false || result?.IsSuccess === false) {
    throw new Error(
      result?.message || result?.Message || "آپلود پیوست ناموفق بود."
    );
  }

  const rows = Array.isArray(result?.data)
    ? result.data
    : Array.isArray(result?.Data)
      ? result.Data
      : [];

  return prepared.map(({ file, sha256 }, index) => {
    const row = rows[index] || {};
    const directory =
      row.directory || row.Directory || row.previewLink || row.PreviewLink || "";
    return {
      fileName: file.name,
      filePath: directory,
      mimeType: file.type || "application/octet-stream",
      sha256,
    };
  });
};
